import * as yup from 'yup'
import { PRICING_FORM_FIELDS } from 'utils/constants'

const { SPECIAL_PRICE, SLASH_PRICE } = PRICING_FORM_FIELDS

export const updatePricingSchema = yup.object().shape({
  [SPECIAL_PRICE.key]: yup
    .mixed()
    .nullable()
    .test('is-valid-number', 'Invalid Price', (value: any) => {
      if (value === null || value === '') return true // Accepts null or empty string
      return !isNaN(value) && parseFloat(value) >= 0 // Checks if value is a number greater than 0
    }),
  [SLASH_PRICE.key]: yup
    .mixed()
    .nullable()
    .test('is-valid-number', 'Invalid Price', (value: any) => {
      if (value === null || value === '') return true // Accepts null or empty string
      return !isNaN(value) && parseFloat(value) >= 0 // Checks if value is a number greater than 0
    }),
})
